import { colors } from 'shared/styles/colors'
import styled, { css } from 'styled-components'

interface IContainerProps {
  openModal: boolean
}

export const Container = styled.div<IContainerProps>`
  display: none;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-y: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);

  ${props =>
    props.openModal &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`

export const ContentContainer = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 521px;
  height: 518px;
`

export const ContainerHeader = styled.div`
  display: flex;

  justify-content: flex-end;

  width: 100%;
`

export const ContainerDetail = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;

  width: 100%;
`
